import PopoverContainer, {
  PopoverContainerProps,
} from '@/common/components/popover-container';
import Spacer from '@/common/components/spacer';
import HelpSmall from '@/icons/help-small';
import Shipping from '@/icons/shipping';
import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { getDynamicCurrency } from '@/util-conversion/currency/currency-to-string';

export interface ShippingDetailsProps
  extends Pick<PopoverContainerProps, 'contentAlign'> {
  fee?: number;
  /** Market vehicle shipping FROM */
  originMarketName: string;
  /** Market vehicle shipping TO */
  destinationMarketName: string;
  variant: 'body2' | 'body3' | 'body1-invoice';
  bodyClassName?: string;
  hideHelpIcon?: boolean;
}

export default function ShippingDetails({
  fee,
  originMarketName,
  destinationMarketName,
  contentAlign,
  variant,
  bodyClassName,
  hideHelpIcon = false,
}: ShippingDetailsProps) {
  const contents = (
    <div className="flex max-w-[220px] flex-col items-center justify-center p-[16px]">
      <p className={'body3-strong text-center'}>
        {originMarketName} {'->'} {destinationMarketName}
      </p>
      <Spacer variant="height8" />
      <p className="body3 text-center">
        This one-time fee covers the cost of shipping the vehicle to your closest Flexcar
        location.
      </p>
    </div>
  );
  const trigger = (
    <div
      className={cn('flex flex-row items-center gap-[4px]', {
        'py-[16px]': variant === 'body3', // NOTE: padding allows us to give this component a larger click area, making the tooltip easier to trigger for users
      })}
    >
      {variant !== 'body1-invoice' ? (
        <>
          <Shipping />{' '}
        </>
      ) : null}

      <p
        className={cn(
          'select-none', // Prevent text selection as it provides a poor user experience on mobile triggering of the tooltip
          {
            body1: variant === 'body1-invoice',
            body2: variant === 'body2',
            body3: variant === 'body3',
          },
          bodyClassName
        )}
      >
        Shipping{fee ? `: ${getDynamicCurrency(fee)}` : ' fee'}
      </p>

      {!hideHelpIcon ? (
        <HelpSmall
          fillPrimary={variant !== 'body1-invoice' ? colors.neutral60 : colors.neutral0}
          className={cn({
            'mt-[2px]': variant === 'body1-invoice', // When font size is larger we need margin top padding for better icon alignment
          })}
        />
      ) : null}
    </div>
  );

  return (
    <PopoverContainer
      triggerComponent={trigger}
      contents={contents}
      hasArrow={false}
      contentAlign={contentAlign}
      contentSide={'top'}
    />
  );
}
